/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'jquery'
], function(BaseClass, $) {

	var ActionHandler = BaseClass.extend({

		slideout: null,
		pressed: false,

		onPress: function(context) {
			var promise;

			if(!this.pressed) {
				this.pressed = true;
				promise = this.getOptions(context)
					.then(this._createSlideout.bind(this, context));
			} else {
				this.onHide();
				this.pressed = false;
			}

			// allow access to the action controller from the plugin
			context.target.plugin.actionController = this;

			return promise || Promise.resolve();
		},

		onHide: function() {
			if(this.slideout) {
				this.slideout.hide({
					force: true
				});
				this.slideout = null;
			}
		},

		getOptions: function() {
			return Promise.resolve({}); // overridden by subclasses.
		},

		// Private

		_createSlideout: function(context, content) {
			var options = {
				id: 'dashboardPanel',
				reuseSlideout: true,
				position: 'left',
				width: '400px',
				resizable: {
					min: 300
				},
				content: content,
				enableTabLooping: false,
				pinning: {
					float: false,
					isPinned: true,
					display: false
				}
			};
			if (content.title || content.label) {
				options.label = content.title || content.label;
			}

			this.slideout = context.glassContext.appController.currentAppView.openSlideout(options);
			this.slideout.$el.addClass('dashboardPane');
			this.slideout.on('done:show', this._onShow.bind(this, context));
			this.slideout.on('hide', this._onHide.bind(this, context));
		},

		_onShow: function(context) {
			this.pressed = true;
			context.target.plugin.setPressed();

			this._resize();
		},

		_onHide: function(context) {
			this.pressed = false;
			this.slideout = null;

			context.target.plugin.setUnpressed();

			this._resize();
		},

		_resize: function() {
			try {
				$(window).resize();
			} catch (e) {
				console.error(e);
			}
		}

	});

	return ActionHandler;
});
